import { MessageCircle } from "lucide-react";
import { siteConfig } from "../config/siteConfig";

export const WhatsAppFloat = () => {
  const waUrl = `https://wa.me/${siteConfig.contact.whatsappRaw}?text=${encodeURIComponent(
    siteConfig.contact.whatsappMessage,
  )}`;
  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 px-4 py-3 bg-green-500 hover:bg-green-600 text-white font-bold rounded-full shadow-xl hover:shadow-2xl transition-all hover:scale-105"
      data-testid="whatsapp-float-btn"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle className="w-6 h-6" fill="white" />
      <span className="hidden sm:inline text-sm">Fale agora</span>
    </a>
  );
};

export default WhatsAppFloat;
